if (!document.querySelector('.employee-job-bookmark')) {
    return;
}

document.querySelectorAll('.employee-job-bookmark').forEach(function(element) {
    element.addEventListener('click', function() {
        const postId = this.getAttribute('data-job');
        const clickedElement = this;
        let bookmark = clickedElement.classList.contains('added') ? 'remove' : 'add';

        if( bookmark == 'add' ) {
            clickedElement.classList.add('added');
        } else {
            clickedElement.classList.remove('added');
        }
        // Send AJAX request to check meta
        fetch(ajax_callback_data.ajax_url, {
            method: 'POST',
            headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
            body: new URLSearchParams({
                action: 'yakkly_employee_bookmark_job',
                postId: postId,
                bookmark: bookmark,
                nonce: ajax_callback_data.ajax_nonce
            })
        })
        .then(response => response.json())
        .then(data => {
            if (data.success) {
                if( bookmark == 'add' ) {
                    clickedElement.classList.add('added');
                    clickedElement.setAttribute('data-tooltip', 'Remove saved');
                } else {
                    clickedElement.classList.remove('added');
                    clickedElement.setAttribute('data-tooltip', 'Save this job');
                }
            } else {
                if( bookmark == 'add' ) {
                    clickedElement.classList.remove('added');
                } else {
                    clickedElement.classList.add('added');
                }
            }
        });
    });
});
